import AuthRegistrationPage from "@/components/AuthRegistrationPage";

export default function HostRegister() {
  return <AuthRegistrationPage variant="host" />;
}
